module.exports = __webpack_public_path__ + "static/media/cms-labels-icon.1ef0d8dd.svg";